moment = require 'moment'
l = require 'lib/localize'

# Generate a name for a pasted image file, using the current date and time
module.exports = ->
  now = moment()
  name = l 'pasted file name',
    date: now.format('l')
    time: now.format('LTS')

  "#{ name }.png"



// WEBPACK FOOTER //
// ./app/scripts/views/internal/pasted-file-name.coffee